import { State } from '../../types';

export const colorado: State = {
  name: 'Colorado',
  abbreviation: 'CO',
  terms: [
    {
      word: 'Agate',
      phonetic: 'AG-it',
      // audioUrl: '/audio/agate.mp3',
      description: 'A town in Elbert County, pronounced "AG-it," not "uh-GATE."'
    },
    {
      word: 'Arriba',
      phonetic: 'AIR-i-buh',
      // audioUrl: '/audio/buenavista.mp3',
      description: 'A town in eastern Colorado with a unique take on the Spanish word for “up.”'
    },
    {
      word: 'Arvada',
      phonetic: 'ar-VAD-uh',
      // audioUrl: '/audio/arvada.mp3',
      description: 'A city near Denver, pronounced "ar-VAD-uh," not "ar-VAY-duh."'
    },
    {
      word: 'Berthoud',
      phonetic: ' BURR-thud',
      // audioUrl: '/audio/buenavista.mp3',
      description: 'A small town in northern Colorado known for its historical landmarks.'
    },
    {
      word: 'Buena Vista',
      phonetic: 'BYOO-nuh VISS-tuh',
      // audioUrl: '/audio/buenavista.mp3',
      description: 'Town in central Colorado'
    },
    {
      word: 'Cache La Poudre',
      phonetic: 'Cash La POO-der',
      // audioUrl: '/audio/buenavista.mp3',
      description: 'A scenic river in northern Colorado with a rich history in the fur trade.'
    },
    {
      word: 'Cañon City',
      phonetic: 'CAN-yon',
      // audioUrl: '/audio/buenavista.mp3',
      description: 'Known for the Royal Gorge and its nickname, the “Climate Capital of Colorado.”'
    },
    {
      word: 'Chinook',
      phonetic: 'CHIN-nook',
      // audioUrl: '/audio/buenavista.mp3',
      description: 'KRefers to warm, dry winds on the eastern slopes of the Rockies.'
    },
    {
      word: 'Colorado',
      phonetic: 'kol-uh-RAD-oh',
      // audioUrl: '/audio/colorado.mp3',
      description: 'State name pronunciation'
    },
    {
      word: 'Crested Butte',
      phonetic: 'Crested-byoot',
      // audioUrl: '/audio/colorado.mp3',
      description: 'A municipality in Colorado.'
    },
    {
      word: 'De Beque',
      phonetic: 'Duh-BECK',
      // audioUrl: '/audio/colorado.mp3',
      description: 'A historic town in western Colorado known for outdoor recreation.'
    },
    {
      word: 'Del Norte',
      phonetic: 'Del NORT',
      // audioUrl: '/audio/colorado.mp3',
      description: 'A small town in southern Colorado named for its location “of the north.”'
    },
    {
      word: 'Elyria',
      phonetic: 'el-IR-ee-uh',
      // audioUrl: '/audio/elyria.mp3',
      description: 'A neighborhood in Denver, pronounced "el-IR-ee-uh," not "el-EER-ee-uh."'
    },
    {
      word: 'Fruita',
      phonetic: 'FROO-tuh',
      // audioUrl: '/audio/fruita.mp3',
      description: 'A city in Mesa County, pronounced "FROO-tuh," not "FROO-ee-tah."'
    },
    {
      word: 'Gypsum',
      phonetic: 'JIP-sum',
      // audioUrl: '/audio/gypsum.mp3',
      description: 'A town in Eagle County, pronounced "JIP-sum," not "GIP-sum."'
    },
    {
      word: 'Huerfano',
      phonetic: 'WER-fuh-no',
      // audioUrl: '/audio/huerfano.mp3',
      description: 'A county in southern Colorado, pronounced "WER-fuh-no," not "HWER-fah-no."'
    },
    {
      word: 'Kersey',
      phonetic: 'KER-see',
      // audioUrl: '/audio/kersey.mp3',
      description: 'A town in Weld County, pronounced "KER-see," not "KER-zee."'
    },
    {
      word: 'Limon',
      phonetic: 'LIME-on',
      // audioUrl: '/audio/colorado.mp3',
      description: 'Known as the “Hub City” of eastern Colorado..'
    },
    {
      word: 'Louisville',
      phonetic: 'LEW-iss-ville',
      // audioUrl: '/audio/colorado.mp3',
      description: 'A charming town near Boulder known for its historic downtown and outdoor activities.'
    },
    {
      word: 'Montrose',
      phonetic: 'MON-trose',
      // audioUrl: '/audio/montrose.mp3',
      description: 'A city in western Colorado, pronounced "MON-trose," not "mon-TROSE."'
    },
    {
      word: 'Olathe',
      phonetic: 'Oh-LAY-thuh',
      // audioUrl: '/audio/colorado.mp3',
      description: 'Famous for its sweet corn and annual corn festival.'
    },
    {
      word: 'Ouray',
      phonetic: 'YOU-ray',
      // audioUrl: '/audio/colorado.mp3',
      description: ' A picturesque town nicknamed the “Switzerland of America.”'
    },
    {
      word: 'Pueblo',
      phonetic: 'PWEH-blo',
      // audioUrl: '/audio/pueblo.mp3',
      description: 'City in southern Colorado'
    },
    {
      word: 'Saguache',
      phonetic: 'suh-WATCH',
      // audioUrl: '/audio/saguache.mp3',
      description: 'A county and town, pronounced "suh-WATCH," not "sah-GWACH-ee."'
    },
    {
      word: 'Salida',
      phonetic: 'Suh-LIE-duh',
      // audioUrl: '/audio/pueblo.mp3',
      description: 'Known as the “Heart of the Rockies.”'
    },
    {
      word: 'Sawatch',
      phonetic: 'suh-WATCH',
      // audioUrl: '/audio/sawatch.mp3',
      description: 'A mountain range, pronounced "suh-WATCH," not "saw-WATCH."'
    },
    {
      word: 'Tejon',
      phonetic: 'TAY-hone',
      // audioUrl: '/audio/pueblo.mp3',
      description: 'A major street in Colorado Springs.'
    },
    {
      word: 'Towaoc',
      phonetic: 'TOY-yock',
      // audioUrl: '/audio/pueblo.mp3',
      description: 'A Ute Mountain Ute tribal community.'
    },
    {
      word: 'Uncompahgre',
      phonetic: 'Un-kum-PAH-gray',
      // audioUrl: '/audio/pueblo.mp3',
      description: 'A river, mountain range, and plateau in western Colorado.'
    },
    {
      word: 'Wynkoop Street',
      phonetic: 'Wine-COOP',
      // audioUrl: '/audio/pueblo.mp3',
      description: 'A notable street in Denver, home to the historic Wynkoop Brewing Company.'
    },
        {
      word: 'Zuni Street',
      phonetic: 'ZOO-nigh',
      // audioUrl: '/audio/pueblo.mp3',
      description: 'Named after the Zuni Native American tribe, located in Denver.'
    }
  ]
};